// extracted by mini-css-extract-plugin
export default {"channel-no-border":"Queues_channel-no-border__5uy6z","rounded-icon":"Queues_rounded-icon__IaXwX","loading-value":"Queues_loading-value__rFE9e"};